import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-account\"><path d=\"M128 213.333v597.334C128 857.6 166.4 896 213.333 896h597.334C857.6 896 896 857.6 896 810.667V213.333C896 166.4 857.6 128 810.667 128H213.333C166.4 128 128 166.4 128 213.333zM640 384c0 72.533-55.467 128-128 128s-128-55.467-128-128 55.467-128 128-128 128 55.467 128 128zM256 725.333C256 640 426.667 593.067 512 593.067S768 640 768 725.333V768H256v-42.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol